import React, { useCallback } from 'react';
import { EMediaType } from '@umu/umu-types';
import { FileSelect, IMG_MAX_SIZE, IEndData } from '../../../fileSelect/fileSelect';
import { SnackBar } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
export type { IEndData } from '../../../fileSelect/fileSelect';

interface IProps {
    multiple: boolean;
    mediaType: EMediaType;
    disabled?: boolean;
    teacherId: string;
    onlyPreview?: boolean;
    limit?: number;
    onClick?: (e: React.MouseEvent) => void;
    validate?: (files: File[]) => boolean;
    fileSelectedCallback?: () => void;
    onEnd?: (data: IEndData[]) => void;
    onUploadError?: (e: Error) => void;
    onData?: (previewUrl: string, url: string, fileName: string, resourceId: string) => void;
    onPreview?: (objectUrl: string, file: File) => void;
    onSelectReady?: (files: Array<{ file: File; previewUrl: string }>) => void;
    buttonClass?: string;
    children?: React.ReactNode;
}

export function PhotoBrowserUploader(props: IProps) {
    const { mediaType, disabled = false, multiple = false, limit = Infinity } = props;
    const onData = (previewUrl: string, url: string, fileName: string, resourceId: string) => {
        props.onData && props.onData(previewUrl, url, fileName, resourceId);
    };

    const validate = useCallback((files: FileList) => {
        const fileList = Array.from(files || []);
        if (fileList.some((file) => file.size > IMG_MAX_SIZE)) {
            SnackBar.show(lang('图片大小限制：10M'));
            return false;
        }
        if (multiple && fileList.length > limit) {
            SnackBar.show(lang('超出数量限制'));
            return false;
        }
        return props.validate ? props.validate(fileList) : true;
    }, []);

    const onClick = (e: React.MouseEvent) => {
        if (props.onClick) {
            props.onClick(e);
        }
    };

    return (
        <div className="photo-browser-uploader" onClick={onClick}>
            <FileSelect
                disabled={disabled}
                multiple={multiple}
                onlyPreview={props.onlyPreview}
                mediaType={mediaType}
                teacherId={props.teacherId}
                className={props.buttonClass}
                validate={validate}
                onUploadError={props.onUploadError}
                onData={onData}
                onEnd={props.onEnd}
                onStart={props.fileSelectedCallback}
                onPreview={props.onPreview}
                onSelectReady={props.onSelectReady}
            >
                {props.children}
            </FileSelect>
        </div>
    );
}
